import React from 'react';
import MainContent from '../../components/mainContent/MainContent';
import { PacienteProbableCreationContent } from './components/PacienteProbableCreationContent';

export default function PacienteProbableCreation() {

    return (
        <MainContent
            component={<PacienteProbableCreationContent />}
            titulo='Nuevo ingreso'
            noBackground
        />
    );

};